// Public API exports for the RMC order intake feature
export {JobSiteSelectionModal} from './components/JobSiteSelectionModal'
export {RmcBulkOrderEdit} from './components/bulkOrderEdit/RmcBulkOrderEdit'

export {RmcOrderIntakeProcessProvider} from './containers/RmcOrderIntakeProcessProvider'
export {RmcOrderIntakeFlowContainer} from './containers/RmcOrderIntakeFlowContainer'
export {RmcStepperContainer} from './containers/RmcStepperContainer'

export {JobSiteProvider, useJobSite} from './contexts/JobSiteContext'

export {useEnhancedLoadSpacingAdjustment} from './hooks/useEnhancedLoadSpacingAdjustment'
export {useEnhancedLoadSpacingScenario} from './hooks/useEnhancedLoadSpacingScenario'
export {useJobSiteSelectionModal} from './hooks/useJobSiteSelectionModal'
export {useJobSitesForModal} from './hooks/useJobSitesForModal'
export {useMaterialPoNumber} from './hooks/useMaterialPoNumber'
export {useOrderRequestSites, warmupSitesEndpoint} from './hooks/useOrderRequestSites'
export {useOrderStatusCheck} from './hooks/useOrderStatusCheck'
export {
  useRegionFeatures,
  useStepConfigurations,
  useDetailsScreenFields
} from '../shared/order-editor/hooks/useRegionConfig'
export {useRmcBulkOrderEdit} from './hooks/useRmcBulkOrderEdit'
export {useRmcCountryFeatures} from '../shared/order-editor/hooks/useRmcCountryFeatures'
export {useRmcOrderIntakeOptionsV2} from './hooks/useRmcOrderIntakeOptionsV2'
export {useRmcPersistedOrderInitialization} from './hooks/useRmcPersistedOrderInitialization'

export * from './services/rmcOrderPersistenceService'
export * from './services/rmcOrderPlacementService'

export type {OrderIntakeSite} from './types/OrderIntakeSite.types'
export {isSearchQueryIncludedInString} from './types/OrderIntakeSite.types'
export type {TransactionResultType} from './types/confirmationResult'
export {OrderRequestStatus} from './types/confirmationResult'
export type {RmcOrder, RmcBulkOrderEditState, RmcOrderPlacementResult} from './types/order'
export {RmcOrderStatus} from './types/order'

export {getTranslatedErrorMessage} from './utils/errorTranslation'
export {formatJobSiteInfo} from './utils/jobSiteUtils'
export {validateOrderDataBasedOnRegionConfig} from './utils/orderUtils'
export {phoneNumberToString, parsePhoneNumber} from './utils/phoneNumberUtils'
export {hasPersistedOrders, validatePersistedOrderMaterials} from './utils/persistedOrderValidation'

export {
  STEP_VALIDATION_CONFIG,
  STEP_INDEX_TO_TYPE_MAP,
  getStepValidationFields,
  hasStepValidation,
  validateStep,
  hasRequiredStepData
} from './validation/stepValidationConfig'
export {useStepNavigation, useStepValidationTrigger} from './validation/useStepValidation'
export {useStepperButtonState} from './validation/useStepperButtonState'

export type {RegionFeatures} from './config/regionFeatures'
export {rmcStepFactories} from './config/rmcStepFactories'
export type {RmcStepConfiguration} from './config/rmcStepFactories'
export {DEFAULT_STEP_ORDER} from './config/stepConfig'
export type {StepOrderingConfig, StepConfig} from './config/stepConfig'
export {RmcOrderIntakeStepType} from './config/stepTypes'
